export default {
  GET_BRANDS: "GET_BRANDS",
  GET_BRANDS_BY_CATEGORY: "GET_BRANDS_BY_CATEGORY",
  CHANGE_ACTIVE_CATEGORY: "CHANGE_ACTIVE_CATEGORY",
  GET_BRAND_BY_ID: "GET_BRAND_BY_ID",
}
